export enum SmartReadFrequencies {
  HALF_HOURLY = "HALF_HOURLY",
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
}

export interface IConsent {
  mpxn: string
  frequency: SmartReadFrequencies
  meterPointId?: string
}

export interface IConsentDetails extends IConsent {
  meterType: string
}
